export enum QuestionType {
  rating = 1,
  singleChoice = 2,
  multipleChoice = 3,
  textField = 4,
  instructorAssessment = 5,
  surveySection = 6,
  ratingsTable = 7,
  fileUpload = 8,
}

export interface QuestionChoice {
  id: string | null;
  uid: string;
  name: string;
  nameFr: string;
  notesField: {
    show: boolean;
    isMandatory: boolean;
    placeholderText: string | null;
  };
}

export enum SurveySectionType {
  general = 1,
  participantDetails = 2
}

export interface QuestionRatingDefinition {
  name: string | null;
  nameFr: string | null;
}
export interface Question {
  id: number | null;
  uid: number | string | null;
  typeId: QuestionType | null;
  rm: boolean;
  name: string | null;
  nameFr: string | null;
  description: string | null;
  descriptionFr: string | null;
  allowSubQuestions: boolean;
  allowNotes: boolean;
  groupName: string | null;
  isMandatory: boolean;
  options: {
    displayInOneLine: boolean;
    ratingMin: number | null;
    ratingMax: number | null;
    ratingNotApplicable: boolean;
    ratingDefinitions: QuestionRatingDefinition[];
    ratingTableChoiceWidth: number | null;
    choices: QuestionChoice[];
    sectionTypeId: SurveySectionType | null;
    showRatingDefinitions: boolean;
    notesMandatory: boolean;
    notesCustomLabel: boolean;
    notesLabel: string | null;
    notesLabelFr: string | null;
    notesMinLength: number | null;
    uploadCountMax: number | null;
    textMinLength: number  | null;
    choicesInSingleColumn: boolean;
  };
  subQuestions: Question[];
}

export interface SurveyReportColumn {
  id: number | string;
  title: string;
}

export interface SurveyReportExpertAssessmentQuestion {
  id: number;
  nr: number;
  name: string;
  typeId: QuestionType;
}

export interface SurveyReportQuestionChoice {
  id: string;
  name: string;
}

export interface SurveyReportQuestion {
  id: string;
  nr: string;
  name: string;
  title: string; // title that can be changed by user
  enabled: boolean;
  columns: Record<string, string | null>;
  choices: SurveyReportQuestionChoice[];
}

export interface SurveyReportData {
  saved: boolean;
  surveyQuestions: SurveyReportExpertAssessmentQuestion[];
}

export interface SurveyReportSettings {
  columns: SurveyReportColumn[];
  questions: SurveyReportQuestion[];
  overallAssessmentQuestionId: number | null;
  additionalSurveyAQuestionId: number | null;
  additionalSurveyBQuestionId: number | null;
  additionalSurveyCQuestionId: number | null;
}
